import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import Blamable            from '@/models/traits/Blamable';
import { Addable }         from '@widesk-core/decorators/addable';
import { Editable }        from '@widesk-core/decorators/editable';
import { Deletable }       from '@widesk-core/decorators/deletable';
import { Timestampable }   from '@widesk-core/decorators/timestampable';
import { Translatable }    from '@widesk-core/decorators/translatable';

@doc.path('/advertisements/{?id}')
@doc.addable
@doc.editable
@doc.deletable
@doc.timestampable
@doc.translatable({ link: true })
abstract class AbstractAdvertisementModel extends Blamable(
	WebsiteServiceModel,
) {
	declare protected _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'title': id;
		'redirectCount': string;
	};

	declare private _tsSorts: {
		id: string;
		title: string;
		redirectCount: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.string declare title: string;
	@doc.number declare redirectCount: number;
}

interface AbstractAdvertisementModel
	extends Addable,
		Editable,
		Deletable,
		Timestampable,
		Translatable<{ link: true }> {}

export default AbstractAdvertisementModel;
